"use strict";
module.exports = {
    deviationReasons: {
        orderLineAdded: 'ORDER_LINE_IS_ADDED',
        orderLineRejected: 'ORDER_LINE_IS_REJECTED',
        orderLineChanged: 'ORDER_LINE_IS_CHANGED',
        orderLineAccepted: 'ORDER_LINE_IS_ACCEPTED',
        orderLineAlreadyDelivered: 'ORDER_LINE_IS_ALREADY_DELIVERED',
    },
};
